import { Guid, IBaseModel } from '~/interfaces/base'
import emptyId from '@/statics/empty-id'

export class PersonnelCategory implements IBaseModel {
  id: Guid
  companyId: Guid
  name: string

  constructor() {
    this.id = emptyId
    this.name = ''
    this.companyId = emptyId
  }
}